import React, { useEffect, useMemo } from "react";
import { Button, Icon, Progress, Table, Upload } from "antd";
import { Redirect } from "react-router-dom";

import Base from "../../../components/Base";
import { TableColumns } from "./table-columns";
import { FetchStatus, useFetchFiles } from "./use-fetch-files";
import { format } from "../../../utils/DateFormater";
import { UploadStatus, useFileUpload } from "./use-file-upload";
import { isSuperUser } from "../../../utils/is-superuser";

import "./styles.css";

function formatFileName(path) {
  if (String(path).includes("/media/")) {
    return path.split("/media/")[1];
  }

  return path;
}

export const AtualizacaoParcelas = () => {
  const { status, data, refresh } = useFetchFiles();
  const { upload, filename, progress, status: uploadStatus } = useFileUpload();

  useEffect(
    function onUploadComplete() {
      if (uploadStatus === UploadStatus.SUCCESS) {
        refresh();
      }
    },
    [uploadStatus]
  );

  if (!isSuperUser()) {
    return <Redirect to="/dashboard" />;
  }

  const tableData = useMemo(
    () =>
      (data || []).map(file => ({
        key: file.id,
        status: [file.status, file.erro], // bool
        file: formatFileName(file.file),
        dt_cadastro: file.dt_cadastro ? format(file.dt_cadastro) : "---",
        dt_processamento: file.dt_processamento
          ? format(file.dt_processamento)
          : "---",
        saida: file.saida
      })),
    [data]
  );

  const isUploading =
    uploadStatus === UploadStatus.UPLOADING ||
    uploadStatus === UploadStatus.ERROR ||
    uploadStatus === UploadStatus.SUCCESS;
  const isFailed = uploadStatus === UploadStatus.ERROR;
  const isSuccess = uploadStatus === UploadStatus.SUCCESS;
  const urlDownloadModeloPlanilha = `${process.env.REACT_APP_API_URL}/media/modelo-planilha-atualizacao-parcelas.xlsx`;

  return (
    <Base
      title="Atualização de Parcelas"
      subTitle="Atualizar parcelas em lote"
      extra={[
        <a href={urlDownloadModeloPlanilha}>
          <Button icon="download" type="ghost">
            Baixar modelo
          </Button>
        </a>,
        <Upload
          name="file"
          accept=".xlsx"
          customRequest={upload}
          showUploadList={false}
        >
          <Button
            type="primary"
            disabled={isUploading && progress !== 100 && !isFailed}
          >
            <Icon type="upload" />
            Fazer upload (.xlsx)
          </Button>
        </Upload>
      ]}
    >
      <div className="upload__container">
        <div className="upload__title">
          <Icon type="file-text" />
          <span>Lista de importações</span>
        </div>

        {isUploading && (
          <div className="upload__progress">
            <span>
              {!isFailed && !isSuccess && <Icon type="loading" />}
              &nbsp;
              <span style={{ opacity: 0.6 }}>{filename}</span>
            </span>
            <Progress
              percent={progress}
              status={isFailed ? "exception" : isSuccess ? "success" : "active"}
            />
          </div>
        )}

        <Table
          pagination={false}
          dataSource={tableData}
          columns={TableColumns}
          loading={status === FetchStatus.LOADING}
          scroll={{ x: true }}
          locale={{
            emptyText: "Vazio"
          }}
        />
      </div>
    </Base>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/AtualizacaoParcelas/index.jsx